export const dataTypeOptions = [
  {
    key: 0,
    title: '服务数据'
  },
  {
    key: 1,
    title: '业绩数据'
  }
]
export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
// 服务数据
export const columnsOfService = [
  {
    title: '组织/人员',
    dataIndex: 'hname',
    width: 150,
    slots: { customRender: 'hname' }
  },
  {
    title: '新增备案客户数',
    dataIndex: 'recordClientNum',
    width: 150,
    sorter: true
  },
  {
    title: '活跃客户数',
    dataIndex: 'activeCnt',
    width: 150,
    sorter: true
  },
  {
    title: '扫码患者数',
    dataIndex: 'scanCodePatientNum',
    width: 150,
    sorter: true
  },
  {
    title: '建档患者数',
    dataIndex: 'registerPatientNum',
    width: 150,
    sorter: true
  },
  {
    title: '服务患者数',
    dataIndex: 'servicePatientNum',
    width: 150,
    sorter: true
  },
  {
    title: '服务客户人次',
    dataIndex: 'serviceClientCnt',
    width: 150,
    sorter: true
  },
  {
    title: '应复诊人数',
    dataIndex: 'shouldConsultNum',
    width: 150,
    sorter: true
  },
  {
    title: '线上复诊数',
    dataIndex: 'onlineConsultCnt',
    width: 150,
    sorter: true
  },
  {
    title: '线下预约数',
    dataIndex: 'offlineReserveCnt',
    width: 150,
    sorter: true
  },
  {
    title: '备案客户数',
    dataIndex: 'recordCnt',
    width: 150,
    slots: { customRender: 'recordCnt' },
    sorter: true
  },
  {
    title: '绑定患者人数',
    dataIndex: 'bindPatientNum',
    width: 150,
    sorter: true,
    slots: { customRender: 'bindPatientNum' }
  }
]
// 业绩数据
export const columnsOfPerformance = [
  {
    title: '组织/人员',
    dataIndex: 'hname',
    width: 150,
    slots: { customRender: 'hname' }
  },
  {
    title: '当期销售额',
    dataIndex: 'sales',
    width: 150,
    sorter: true
  },
  {
    title: '当期新特药销售额',
    dataIndex: 'spSales',
    width: 180,
    sorter: true
  },
  {
    title: '当期中药销售额',
    dataIndex: 'cnSales',
    width: 150,
    sorter: true
  },
  {
    title: '当期主推健康用品销售额',
    dataIndex: 'mainHlSales',
    width: 220,
    sorter: true
  },
  {
    title: '当期常规健康用品销售额',
    dataIndex: 'routineHlSales',
    width: 220,
    sorter: true
  },
  {
    title: '当期常用药销售额',
    dataIndex: 'usSales',
    width: 220,
    sorter: true
  },
  {
    title: '当期推荐处方无修改开具数',
    dataIndex: 'recomNotModifyCnt',
    width: 220,
    sorter: true
  },
  {
    title: '当期推荐处方无修改销售额',
    dataIndex: 'recomNotModifyXtyISales',
    width: 220,
    sorter: true
  },
  {
    title: '当期临观线上处方结算数',
    dataIndex: 'recomAccountOnlineCnt',
    width: 220,
    sorter: true
  },
  {
    title: '当期临观线下处方结算数',
    dataIndex: 'recomAccountOfflineCnt',
    width: 220,
    sorter: true
  },
  {
    title: '当期处方数',
    dataIndex: 'recomCnt',
    width: 150,
    sorter: true
  },
  {
    title: '当期已购处方数',
    dataIndex: 'buyRecomCnt',
    width: 150,
    sorter: true
  },
  {
    title: '当期转化率',
    dataIndex: 'conRate',
    width: 150,
    sorter: true,
    customRender: ({ text }) => {
      return text ? Number(text * 100).toFixed(2) + '%' : text
    }
  },
  {
    title: '当期已购客单价',
    dataIndex: 'buyUnitPrice',
    width: 150,
    sorter: true
  }
]
